import { Link } from 'react-router-dom';
import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <>
      <SEOHead
        title="页面未找到"
        description="抱歉，您访问的页面不存在。请返回首页浏览羊宫妃那词条百科的精彩内容。"
      />
      <Navbar />
      <div className="min-h-screen flex items-center justify-center pt-16">
        <div className="text-center px-4">
          <div className="text-8xl md:text-9xl font-black text-foreground-100 select-none mb-4">
            404
          </div>
          <h1 className="text-xl md:text-2xl font-bold text-foreground-950 mb-3">
            页面未找到
          </h1>
          <p className="text-foreground-500 mb-8">
            抱歉，您访问的页面不存在或已被移除。
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            返回首页
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
}